import {logoutUser} from '../actions/loginActions';
import {saveUserImageBase64, saveUserSignBase64, showAlert} from '../actions/miscellaneousActions';
import {NO_PIC_IMAGE, NO_SIGN} from '../constants/generals';
import {del, get, post, put} from '../HTTP';
import {IHistory} from '../interfaces';
import {UserModel} from '../model/UserModel';
import {store} from '../store';
import {base64ToFile, getBase64, getCurrentUserUUID, uploadDocsToS3, getBase64BIT} from '../utils/generalUtils';
import {getUserData, removeUserData} from './utilityServices';

require('formdata-polyfill');

const uuidv1 = require('uuid/v1');

function mapUserData(params, profilePicURL, signatureURL) {
    const data = {
        Company: params.company || '',
        First_Name: params.firstName,
        Middle_Name: params.middleName.length === 0 ? '' : params.middleName,
        Last_Name: params.lastName,
        Email: params.email,
        Access_Level: params.accessLevel,
        Job_Title: params.jobTitle,
        Job_Desc: params.jobDesc,
        PhoneNumber: params.phoneNum || '',
        SignatureURL: signatureURL || '',
        AdminId: getCurrentUserUUID(),
        Modules: params.modules || [],
        UserImage: profilePicURL
    };
    if (params.userId) {
        data['UserId'] = Number(params.userId);
        data['Password'] = params.password;
    }

    if (params.accessLevel === 'L1') {
        data['organization'] = '';
    } else {
        data['organization'] = params.organization;
    }

    return data;
}

export async function submitUserForm(params, files, history: IHistory) {
    try {
        const data = mapUserData(params, '', '');
        const response = await post('/AddUser', data);
        showAlert({
            title: 'Thanks.!!',
            text: `User ${params.firstName} is created..!!`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/');
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw error;
    }
}

export async function submitBulkUserCreation(data, history: IHistory) {
    try {
        const dataToSend = [];
        data.forEach((user) => {
            const eachUser = {
                ...user,
                PhoneNumber: '',
                SignatureURL: '',
                AdminId: getCurrentUserUUID(),
                Modules: [],
                UserImage: ''
            };
            dataToSend.push(eachUser);
        });
        return await post('/BulkUser', data);
    } catch (e) {
        showAlert({
                title: 'Oops..!!',
                text: e,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw e;
    }
}
export async function updateUser(params, files, profilePic, sign, history: IHistory, userID: string) {
    try {
        let profilePicData = {location: ''};
        let signData = {location: ''};
        let ProfileImgUploadFile : any[]; 
        let SignImgUploadFile : any[]; 
        // let base64BIT = {location: ''};
        const data = mapUserData(params, profilePicData.location, signData.location);
        data.AdminId = getCurrentUserUUID();
        if (profilePic) {
            const extension = profilePic.type.split('/')[1];
            const proFile = new Blob([profilePic], {type: 'image/png'});
            const profilePicFile = new FormData();
            const base64BITImg = await getBase64BIT(profilePic);
            profilePicFile.append('ProfilePic', proFile, `${uuidv1()}.${extension}`);
            ProfileImgUploadFile = [base64BITImg, `${uuidv1()}.${extension}`];
            data.UserImage = ProfileImgUploadFile;
        }
        if (sign) {  
            // const signFile = new Blob([sign], {type: 'image/png'});
            // const data = new FormData();
            // data.append('SignFile', signFile, `${uuidv1()}.png`);
            const base64BITSign = await getBase64BIT(sign);
            SignImgUploadFile = [base64BITSign, `${uuidv1()}.png`];
            data.SignatureURL = SignImgUploadFile;
            // signData = await uploadDocsToS3(data.get('SignFile'), 'demo');
        }
       const response = await put(`/UpdateUser/${userID}`, data);
        if (userID === getCurrentUserUUID()) {
            saveUserImageBase64(ProfileImgUploadFile[0]);
            saveUserSignBase64(SignImgUploadFile[0]);
        }
        showAlert({
            title: 'Thanks.!!',
            text: `User ${params.firstName}'s information is updated..!!`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/');
            }
        }, 'submission', 5000);
        await getUserDetails(userID);
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw error;
    }
}

export async function getAllUsers() {
    try {
        UserModel.deleteAllInstances();
        const response = await get('/GetUsers', {});
        await getUserDetails(getCurrentUserUUID());
        (response.data || []).forEach(instance => {
            instance.id = instance.UniqueID;
            instance.Access_Level = instance.Access_Level || 'L1';
            instance.AccessLevel = instance.Access_Level;
            instance.JobTitle = instance.JobTitle;
            if (instance.id !== getCurrentUserUUID()) {
                new UserModel(instance).$save();
            }
        });
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function deactivateUser(userID: string, userName: string, status: boolean, history: IHistory) {
    try {
        const response = await del(`/DeleteUser/${userID}?Active=${status ? 1 : 0}`, {});
        UserModel.deleteAllInstances();
        showAlert({
            title: 'Success...!!',
            text: `User ${userName}'s account is ${status ? 'Activated' : 'Deactivated'}.`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/users/list');
            }
        }, 'submission', 5000);
        await getAllUsers();
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function getUserDetails(userUID: string) {
    try { 
        const userData = getUserData();
        const category = userData.category || 'all';
        const response = await get(`GetOneUser/${userUID}/${category}`, {});

        if (!response.data) {
            return;
        }
        response.data.id = (response.data || {}).UniqueID;
        response.data.JobDesc = response.data.JobDescription;
        let userImageBase64 = NO_PIC_IMAGE;
        let signURLBase64 = NO_SIGN;
        let signFile = null;
        let profilePicFile = null;
        const userImageBase64Data = store.getState().miscellaneous.get('userImageBase64');
        const userSignBase64Data = store.getState().miscellaneous.get('userSignBase64');
        const isLoggedInUser = userUID === getCurrentUserUUID();

        if (response.data.UserImage && (isLoggedInUser && !userImageBase64Data)) {
            userImageBase64 = await getBase64(response.data.UserImage);
            profilePicFile = await base64ToFile(`data:image/png;base64,${userImageBase64}`, 'profilePic.png');
        }
        if (response.data.SignURL && (isLoggedInUser && !userSignBase64Data)) {
            signURLBase64 = await getBase64(response.data.SignURL);
            signFile = await base64ToFile(`data:image/png;base64,${signURLBase64}`, 'signFile.png');
        }
        if (response.data.UserImage && !isLoggedInUser) {
            userImageBase64 = await getBase64(response.data.UserImage + '?expires=' + Date.now());
            profilePicFile = await base64ToFile(`data:image/png;base64,${userImageBase64}`, 'profilePic.png');
        }
        if (response.data.SignURL && !isLoggedInUser) {
            signURLBase64 = await getBase64(response.data.SignURL);
            signFile = await base64ToFile(`data:image/png;base64,${signURLBase64}`, 'signFile.png');
        }
        if (isLoggedInUser && (!userImageBase64Data || !userSignBase64Data)) {
            saveUserImageBase64(`data:image/png;base64,${userImageBase64}`);
            saveUserSignBase64(`data:image/png;base64,${signURLBase64}`);
        }
        if (isLoggedInUser && (userImageBase64Data || userSignBase64Data)) {
            signFile = await base64ToFile(userSignBase64Data, 'signFile.png');
            profilePicFile = await base64ToFile(userImageBase64Data, 'profilePic.png');
        }
        response.data.UserImage = `data:image/png;base64,${userImageBase64}`;
        response.data.SignURL = `data:image/png;base64,${signURLBase64}`;
        response.data.ProfilePicFile = profilePicFile;
        response.data.SignFile = signFile;
        new UserModel(response.data).$save();
    } catch (error) {
        if(error == 'Unauthorized access'){
            logoutUser();
            removeUserData();
        }

        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function updateUserPassword(oldPassword: string, newPassword: string, confirmPassword: string, email: string, history: IHistory) {
    try {
        const response = await put('/UpdatePassword', {
            UserId: email,
            OldPwd: oldPassword,
            NewPwd: newPassword
        });
        logoutUser();
        removeUserData();
        showAlert({
            title: 'Thanks..!!',
            text: `Password Updated..!! Login again with new password to continue.`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/');
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export async function submitUserFeedback(feedback: string, userId: string, history: IHistory) {
    try {
        const response = await post('/AddUserFeedback', {
            UserId: Number(userId),
            Comment: feedback
        });
        showAlert({
            title: 'Thanks..!!',
            text: `Feedback Sumbitted..!!`,
            type: 'success',
            closeOnConfirm: true,
            confirmCallback: () => {
                history.push('/');
            }
        }, 'submission', 5000);
    } catch (error) {
        showAlert({
                title: 'Oops..!!',
                text: error,
                type: 'error',
                closeOnConfirm: true
            },
            'submission');
        throw new Error(error);
    }
}

export const getUsersByLevel = async () => {
    try {
        const response = await get('/GetUsersByLevel', {});
        return response.data || null;
    } catch (error) {
        console.error("Failed to fetch L2 user:", error);
        return null;
    }
};

export const getOrgMFAStatus = async () => {
    try {
        const response = await get('/toggleOrgMfa', {});
        return response;
    } catch (error) {
        console.error('Get Org MFA error:', error);
        throw error;
    }
};

export const toggleOrgMFA = async (enable: boolean) => {
    try {
        const response = await put('/toggleOrgMfa', { enable });
        return response;
    } catch (error) {
        console.error('Toggle Org MFA error:', error);
        throw error;
    }
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/userService.ts